module.exports = __webpack_public_path__ + "img/desk_closeup.a0533271.jpeg";